module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAJYAQMAAADL0F5mAAAABlBMVEXOEST////862ZCAAABCElEQVR42u3bMREAAAgDMfybhpm1E9zlBTQKWp1Vu3SFTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9P/6pIkSZIkSZIkSZIkSZIkSZIkSZIkSdLlPJHpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Oj1qAOiafcQwCtArAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-eng.png
// module id = 1770
// module chunks = 0